<template>
    <div class="form-item">
        <div class="label">
            <b class="icon" v-if="isRequired"></b>
            <label>
                {{ label }}
            </label>
        </div>
        <div class="box">
            <slot></slot>
            <p v-if="validateMessage">{{ validateMessage }}</p>
        </div>
    </div>
</template>

<script>
import AsyncValidator from 'async-validator'
import emitter from '@/mixins/emitter.js';
export default {
    name: 'TsaFormItem',
    componentName: 'TsaFormItem',
    inject: ['tsaForm'],
    provide() {
      return {
        tsaFormItem: this
      };
    },
    props: {
        label: {
            type: String,
        },
        prop: {
            type: String,
        },
    },
    data () {
        return {
            validator: {},
            validateState: '',
            validateMessage:'',
            validateDisabled:false
        }
    },
    components: {},
    mixins: [emitter],
    watch: {
        error: {
            immediate: true,
            handler(value) {
                this.validateMessage = value;
                this.validateState = value ? 'error' : '';
            }
        },
        validateStatus(value) {
            this.validateState = value;
        },
        rules(value) {
            if ((!value || value.length === 0)) {
                this.clearValidate();
            }
        }
    },
    computed: {
        form() {
            let parent = this.$parent;
            let parentName = parent.$options.componentName;
            while (parentName !== 'TsaForm') {
                parent = parent.$parent;
                parentName = parent.$options.componentName;
            }
            return parent;
        },
        fieldValue() {
            const model = this.form.model;
            if (!model || !this.prop) { return; }

            let path = this.prop;
            if (path.indexOf(':') !== -1) {
            path = path.replace(/:/, '.');
            }
            return this.getPropByPath(model, path, true).v;
        },
        isRequired() {
            let rules = this.getRules();
            let isRequired = false;
            if (rules && rules.length) {
                rules.every(rule => {
                    if (rule.required) {
                        isRequired = true;
                        return false;
                    }
                    return true;
                });
            }
            return isRequired;
        },
    },
    created() {},
    mounted() {
        if (this.prop) {
            this.dispatch('TsaForm', 'tsa.form.addField', [this]);
            let initialValue = this.fieldValue;
            if (Array.isArray(initialValue)) {
                initialValue = [].concat(initialValue);
            }
            Object.defineProperty(this, 'initialValue', {
                value: initialValue
            });
            this.addValidateEvents();
        }
    },
    beforeDestroy() {
      this.dispatch('TsaForm', 'tsa.form.removeField', [this]);
    },
    methods: {
        getPropByPath(obj, path, strict) {
            let tempObj = obj;
            path = path.replace(/\[(\w+)\]/g, '.$1');
            path = path.replace(/^\./, '');

            let keyArr = path.split('.');
            let i = 0;
            for (let len = keyArr.length; i < len - 1; ++i) {
                if (!tempObj && !strict) break;
                let key = keyArr[i];
                if (key in tempObj) {
                tempObj = tempObj[key];
                } else {
                if (strict) {
                    throw new Error('please transfer a valid prop path to form item!');
                }
                break;
                }
            }
            return {
                o: tempObj,
                k: keyArr[i],
                v: tempObj ? tempObj[keyArr[i]] : null
            };
        },
        objectAssign(target){
            for (let i = 1, j = arguments.length; i < j; i++) {
                let source = arguments[i] || {};
                for (let prop in source) {
                if (source.hasOwnProperty(prop)) {
                    let value = source[prop];
                    if (value !== undefined) {
                        target[prop] = value;
                    }
                }
                }
            }
            return target;
        },
        addValidateEvents() {
            const rules = this.getRules();
            if (rules.length) {
                this.$on('tsa.form.blur', this.onFieldBlur);
                this.$on('tsa.form.change', this.onFieldChange);
            }
        },
        removeValidateEvents() {
            this.$off();
        },
        resetField() {
            this.validateState = '';
            this.validateMessage = '';

            let model = this.form.model;
            let value = this.fieldValue;
            let path = this.prop;
            if (path.indexOf(':') !== -1) {
                path = path.replace(/:/, '.');
            }

            let prop = this.getPropByPath(model, path, true);

            this.validateDisabled = true;
            if (Array.isArray(value)) {
                prop.o[prop.k] = [].concat(this.initialValue);
            } else {
                prop.o[prop.k] = this.initialValue;
            }

            // reset validateDisabled after onFieldChange triggered
            this.$nextTick(() => {
                this.validateDisabled = false;
            });
            // this.broadcast('ElTimeSelect', 'fieldReset', this.initialValue);
        },
        getRules() {
            let formRules = this.form.rules;
            const prop = this.getPropByPath(formRules, this.prop || '');
            formRules = formRules ? (prop.o[this.prop || ''] || prop.v) : [];
            return [].concat(formRules || []);
        },
        getFilteredRule(trigger) {
            const rules = this.getRules();
            return rules.filter(rule => {
                if (!rule.trigger || trigger === '') return true;
                if (Array.isArray(rule.trigger)) {
                    return rule.trigger.indexOf(trigger) > -1;
                } else {
                    return rule.trigger === trigger;
                }
            }).map(rule => this.objectAssign({}, rule));
        },

        validate(trigger, callback = ()=>{}) {
            this.validateDisabled = false;
            const rules = this.getFilteredRule(trigger);
            if ((!rules || rules.length === 0)) {
                callback();
                return true;
            }
            const descriptor = {};
            if (rules && rules.length > 0) {
                rules.forEach(rule => {
                    delete rule.trigger;
                });
            }
            descriptor[this.prop] = rules;
            const validator = new AsyncValidator(descriptor)
            const model = {};
            model[this.prop] = this.fieldValue;
            validator.validate(model,{ firstFields: true }, (errors, invalidFields) => {
                this.validateState = !errors ? 'success' : 'error';
                this.validateMessage = errors ? errors[0].message : '';
                callback(this.validateMessage, invalidFields);
                this.tsaForm && this.tsaForm.$emit('validate', this.prop, !errors, this.validateMessage || null);
            });
        },
        clearValidate() {
            this.validateState = '';
            this.validateMessage = '';
            this.validateDisabled = false;
        },
        onFieldBlur() {
            this.validate('blur');
        },
        onFieldChange() {
            if (this.validateDisabled) {
                this.validateDisabled = false;
                return;
            }
            this.validate('change');
        },
    },
}

</script>
<style scoped lang='less'>
.form-item{
    margin-bottom:20PX;
    .label{
        margin-bottom:5PX;
        display: flex;
        align-items: center;
        b{
            display:block;
            width: 4PX;
            height: 4PX;
            margin-right: 4PX;
            border-radius: 50%;
            background-color: #F33
        }
        label{
            font-size: 16PX;
            font-weight: 700;
        }
    }
    .box{
        position: relative;
        p{
            position: absolute;
            left: 0;
            bottom: -20PX;
            color: #f5222d;
            font-size: 14PX;
        }
    }
}
@media screen and (max-width: 750px) {
    .form-item{
        margin-bottom:30px;
        .label{
            margin-bottom:12px;
            b{
                width: 8px;
                height: 8px;
                margin-right: 8px;
            }
            label{
                font-size: 28px;
            }
        }
        .box{
            p{
                position: absolute;
                left: 0;
                bottom: -30px;
                font-size: 18px;
            }
        }
    }
}
</style>